import React, { useCallback, useEffect, useState } from 'react'
import { t } from '../../i18n'
import { fetchScales } from './api'

const scope = 'controls'

const WeightScalesSection = () => {
  const [weight, setWeight] = useState<number | null>(null)
  const [unit, setUnit] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<boolean>(false)

  const load = useCallback(async () => {
    setLoading(true)
    setError(false)
    try {
      const { weight: w, unit: u } = await fetchScales()
      setWeight(w)
      setUnit(u)
      if (w === null) setError(true)
    } catch {
      setError(true)
      setWeight(null)
      setUnit(null)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { load() }, [load])

  const refreshLabel = t('scales_refresh', { scope })

  const body = () => {
    if (loading && weight === null) return <div className="text-muted">{t('scales_loading', { scope })}</div>
    if (error || weight === null) return <div className="text-muted">{t('scales_unavailable', { scope })}</div>
    return (
      <div className="d-flex align-items-baseline" style={{ gap: '0.25rem' }}>
        <span className="fs-3 fw-semibold">{weight}</span>
        <span className="text-muted">{unit}</span>
      </div>
    )
  }

  return (
    <div className="card h-100">
      <div className="card-body d-flex flex-column">
        <div className="d-flex align-items-center mb-3" style={{ gap: '0.5rem' }}>
          <h6 className="mb-0 flex-grow-1 ps-2">{t('scales_heading', { scope })}</h6>
          <button
            type="button"
            className="btn btn-sm btn-light border d-inline-flex align-items-center"
            onClick={load}
            disabled={loading}
            title={refreshLabel}
            aria-label={refreshLabel}
            style={{ gap: '0.4rem' }}
          >
            {loading
              ? <span className="spinner-border spinner-border-sm" role="status" />
              : <i className="bi bi-arrow-clockwise" aria-hidden="true" />}
          </button>
        </div>
        <div className="flex-grow-1 d-flex align-items-center justify-content-left ps-2">
          {body()}
        </div>
      </div>
    </div>
  )
}

export default WeightScalesSection
